import React from "react";

const ProblemsSection = ({ title, subtitle, problems }) => {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-5xl mx-auto px-6">
                <h2 className="text-3xl font-bold text-brand-blue mb-4 text-center">{title}</h2>
                {subtitle && (
                    <p className="text-center text-gray-500 text-lg max-w-2xl mx-auto mb-12">{subtitle}</p>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {problems.map((p, i) => (
                        <div key={i} className="bg-yellow-50 border-l-4 border-yellow-500 p-5 rounded-r-lg">
                            <h3 className="font-semibold text-yellow-800 mb-2">{p.title}</h3>
                            <p className="text-yellow-900 text-sm">{p.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProblemsSection;
